import React from "react";
import logo from "../logosm.png";

function Loading() {
  return (
    <div className="loader center">
      <img src={logo} alt="Loading" className="fa logo-spinner fa-spin" />
    </div>
  );
}

export default Loading;
